import api from '../../services/api'
import {
  STORAGE_IS_FETCHING,
  STORAGE_IS_DELETEING,
  STORAGE_SUCCESS,
  STORAGE_UPDATE_CONTENT_TABLE,
  STORAGE_TABLE_ADD_ITEM,
  STORAGE_TABLE_DELETE_ITEM,
  STORAGE_FILTER,
  STORAGE_FILTER_CLEAR,
  STORAGE_FILTERS_ADD_TYPE,
  STORAGE_FILTERS_REMOVE_TYPE,
  STORAGE_UPDATE_TABLE,

  CHANNEL_ASSIGN_FILES,
  CHANNEL_UNASSIGN_FILES,
  CHANNEL_DELETE_DIRECTORIES,
  CHANNEL_DELETE,
  CHANNEL_CREATE_DIRECTORY,
  CHANNEL_CREATE_SMART_DIRECTORY,
  CHANNEL_EDIT_DIRECTORY,
  STORAGE_ADD_TAG,
  STORAGE_REMOVE_TAG,
  STORAGE_ADD_TAGS,

  DOWNLOAD_FILE_ADD,
  DOWNLOAD_FILE_UPDATE,
  DOWNLOAD_CLEAR
} from '../types'

function getStorage () {
  return (dispatch, getState) => {
    dispatch(isFetching(STORAGE_IS_FETCHING, true))

    const params = getState().storage.filters

    return api.storage.getStorage(params).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: STORAGE_SUCCESS,
          payload: response.data.result
        })

        return response
      }
    }).then((response) => {
      dispatch(isFetching(STORAGE_IS_FETCHING, false))
      return response
    })
  }
}

function clearDownloadList () {
  return (dispatch) => {
    dispatch({
      type: DOWNLOAD_CLEAR
    })
  }
}

function downloadStorageFile (file) {
  const guid = file.guid
  const fileName = `${file.name}.${file.extension}`

  return (dispatch) => {
    const callback = (percent) => dispatch({
      type: DOWNLOAD_FILE_UPDATE,
      payload: {
        guid,
        percent
      }
    })

    dispatch({
      type: DOWNLOAD_FILE_ADD,
      payload: {
        guid,
        name: fileName,
        percent: 0
      }
    })

    return api.storage.getStorageFileById(guid, callback).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      link.click()
      window.URL.revokeObjectURL(url)
    })
  }
}

function replaceStorageFileById (guid, params) {
  return (dispatch) => {
    return api.storage.replaceStorageFileById(guid, params).then(response => {
      dispatch(getStorage())
      return response
    })
  }
}

function updateProperties (guid, params) {
  return (dispatch) => {
    return api.storage.updateProperties(guid, params)
  }
}

function updateStorageFileById (guid, params) {
  return (dispatch) => {
    return api.storage.updateStorageFileById(guid, params).then(response => {
      dispatch(getStorage())
      return response
    })
  }
}

function deleteStorageResourceById (guid) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_IS_DELETEING,
      payload: true
    })

    return api.storage.deleteStorageResourceById(guid).then(response => {
      dispatch({
        type: STORAGE_IS_DELETEING,
        payload: false
      })

      dispatch(getStorage())

      return response
    })
  }
}

function deleteStorageResourceByArray (guids) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_IS_DELETEING,
      payload: true
    })

    return api.storage.deleteStorageResourceByArray(guids).then(response => {
      dispatch({
        type: STORAGE_IS_DELETEING,
        payload: false
      })

      dispatch(getStorage())
      return response
    })
  }
}

function uploadStorageFile (response) {
  return (dispatch) => {
    dispatch(getStorage())
  }
}

function updateStorageFile (response) {
  return (dispatch) => {
    dispatch(getStorage())
  }
}

function isFetching (type, payload) {
  return {
    type,
    payload
  }
}

function setTable (keys, rows) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_UPDATE_CONTENT_TABLE,
      payload: {
        keys,
        rows
      }
    })
  }
}

function updateTable () {
  return (dispatch) => {
    dispatch({
      type: STORAGE_UPDATE_TABLE
    })
  }
}

function addTableItem (id, item) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_TABLE_ADD_ITEM,
      payload: {
        id,
        item
      }
    })
  }
}

function removeTableItem (id) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_TABLE_DELETE_ITEM,
      payload: {
        id
      }
    })
  }
}

function setSearch (search) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_FILTER,
      payload: {
        search,
        page: 0
      }
    })

    dispatch(setTable([], []))
    dispatch(getStorage())
  }
}

function setFilterTable (page, pageSize, sort, order) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_FILTER,
      payload: {
        page,
        pageSize,
        sort,
        order
      }
    })

    dispatch(setTable([], []))
    dispatch(getStorage())
  }
}

function setFilterPagination (page, pageSize) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_FILTER,
      payload: pageSize ? {
        page,
        pageSize
      } : {
        page
      }
    })

    dispatch(setTable([], []))
    dispatch(getStorage())
  }
}

function setFilterMatchAllTags (matchAllTags) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_FILTER,
      payload: {
        matchAllTags: matchAllTags,
        page: 0
      }
    })

    dispatch(setTable([], []))
    dispatch(getStorage())
  }
}

function setFilterMatchAnyTags (matchAnyTags) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_FILTER,
      payload: {
        matchAnyTags: matchAnyTags,
        page: 0
      }
    })

    dispatch(setTable([], []))
    dispatch(getStorage())
  }
}

function setFilterMatchNoneTags (matchNoneTags) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_FILTER,
      payload: {
        matchNoneTags: matchNoneTags,
        page: 0
      }
    })

    dispatch(setTable([], []))
    dispatch(getStorage())
  }
}

function addFilesTypeFilter (value) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_FILTERS_ADD_TYPE,
      payload: value
    })

    dispatch({
      type: STORAGE_FILTER,
      payload: {
        page: 0
      }
    })

    dispatch(setTable([], []))
    dispatch(getStorage())
  }
}

function removeFilesTypeFilter (value) {
  return (dispatch) => {
    dispatch({
      type: STORAGE_FILTERS_REMOVE_TYPE,
      payload: value
    })

    dispatch({
      type: STORAGE_FILTER,
      payload: {
        page: 0
      }
    })

    dispatch(setTable([], []))
    dispatch(getStorage())
  }
}

function createStorageAssignmentByArray (id, guids) {
  return (dispatch) => {
    return api.storage.createStorageAssignmentByArray(id, guids).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_ASSIGN_FILES,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function deleteStorageAssignmentByArray (id, guids) {
  return (dispatch) => {
    return api.storage.deleteStorageAssignmentByArray(id, guids).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_UNASSIGN_FILES,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function deleteStorageByArray (ids) {
  return (dispatch) => {
    return api.storage.deleteStorageByArray(ids).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_DELETE_DIRECTORIES,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function deleteStorageById (id) {
  return (dispatch) => {
    return api.storage.deleteStorageById(id).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_DELETE,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function createStorageDirectoryById (id, params) {
  return (dispatch) => {
    return api.storage.createStorageDirectoryById(id, params).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_CREATE_DIRECTORY,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function createSmartDirectoryById (id, params) {
  return (dispatch) => {
    return api.storage.createSmartDirectoryById(id, params).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_CREATE_SMART_DIRECTORY,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function updateSmartDirectory (id, params) {
  return (dispatch) => {
    return api.storage.updateSmartDirectory(id, params).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: CHANNEL_EDIT_DIRECTORY,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

function addTag (guid, id) {
  return (dispatch) => {
    return api.storage.addTag(guid, id).then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: STORAGE_ADD_TAG
        })
      }
      return response
    })
  }
}

function removeTag (guid, id) {
  return (dispatch) => {
    return api.storage.removeTag(guid, id).then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: STORAGE_REMOVE_TAG,
          payload: {
            guid,
            result: response.data.result
          }
        })
      }
      return response
    })
  }
}

function addTags (guid, array) {
  return (dispatch) => {
    return api.storage.addTags(guid, array).then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: STORAGE_ADD_TAGS,
          payload: {
            guid,
            result: response.data.result
          }
        })
      }
      return response
    })
  }
}

function clearFilters () {
  return (dispatch) => {
    dispatch({
      type: STORAGE_FILTER_CLEAR
    })

    dispatch(setTable([], []))
    dispatch(getStorage())
  }
}

export {
  getStorage,
  downloadStorageFile,
  replaceStorageFileById,
  updateProperties,
  uploadStorageFile,
  updateStorageFile,
  setTable,
  updateTable,
  addTableItem,
  removeTableItem,

  setSearch,
  setFilterTable,
  setFilterPagination,
  setFilterMatchAllTags,
  setFilterMatchAnyTags,
  setFilterMatchNoneTags,

  addFilesTypeFilter,
  removeFilesTypeFilter,
  createStorageAssignmentByArray,
  deleteStorageAssignmentByArray,
  deleteStorageByArray,
  deleteStorageById,
  createStorageDirectoryById,
  deleteStorageResourceById,
  deleteStorageResourceByArray,

  updateStorageFileById,

  addTag,
  removeTag,
  addTags,

  createSmartDirectoryById,
  updateSmartDirectory,
  clearFilters,
  clearDownloadList
}



// WEBPACK FOOTER //
// ./src/store/actions/storage.js